/**
 * Applies the `?newViewport` URL override on top of whatever default the
 * caller passes in — this helper does NOT decide the default itself:
 *   - `?newViewport=1` → unified on
 *   - `?newViewport=0` → legacy on (the only escape hatch)
 *   - (absent)         → follows the caller's `isSegmentationProject` argument
 *
 * `HangingProtocolGrid` resolves the grid's flag through `resolveGridReslice`,
 * which passes `true` for every project (segmentation or not) — the grid
 * forces the unified path on unconditionally and always passes the result
 * down to every `ProtocolViewport` as the `unifiedPath` prop, so the
 * `isSegmentationProject`-only default below never actually applies on that
 * path. `ProtocolViewport`'s own `resolveNewViewportFlag(isSegmentationProject)`
 * call (no `param` — it re-reads the URL itself) is a fallback for when
 * `unifiedPath` is omitted; `ProtocolViewport` is only ever rendered by
 * `HangingProtocolGrid`, which always supplies `unifiedPath`, so that fallback
 * branch is not exercised in production today. Kept as a safety net in case a
 * future caller renders `ProtocolViewport` without it.
 *
 * Both `ProtocolViewport` (per-pane render) and `HangingProtocolGrid` (the shared
 * ViewportWorkspace + seg-owner) MUST resolve the flag through this helper so the
 * workspace and the panes can never disagree. Slated for deletion with the legacy
 * branches once the unified default soaks across all projects.
 */

export function resolveNewViewportFlagFrom(
  isSegmentationProject: boolean,
  param: string | null,
): boolean {
  if (param === "1") return true;
  if (param === "0") return false;
  return isSegmentationProject;
}

export function resolveNewViewportFlag(isSegmentationProject: boolean): boolean {
  const param = new URLSearchParams(window.location.search).get("newViewport");
  return resolveNewViewportFlagFrom(isSegmentationProject, param);
}
